<script setup>
import { useHead } from '@unhead/vue';
import { watch, reactive } from "vue";
import { onBeforeRouteUpdate, useRoute } from "vue-router";

const props = defineProps({
    canonical: {
        type: Object,
        default() {
            return {
                totalRecords: 0,
            };
        },
    },
    pageQueryKey: {
        type: String,
        default: 'pageNumb',
    },
    perPageQueryKey: {
        type: String,
        default: 'perPage',
    },
});

const route = useRoute();
const metaInformation = reactive({ link: [] });

if (props.canonical.totalRecords) {
    const calcCanonical = (routeObj) => {
        const pageKey = props.pageQueryKey;
        const perPageKey = props.perPageQueryKey;
        const links = [{ 
            rel: "canonical", 
            href: window.location.origin + routeObj.fullPath,
            key: "canonical"
        }];

        const perPage = parseInt(routeObj.query[perPageKey], 10) || 1;
        const currPage = parseInt(routeObj.query[pageKey], 10) || 1;
        if (currPage > 1) {
            const prevPath = window.location.origin + routeObj.fullPath.replace(
                `${pageKey}=${currPage}`,
                `${pageKey}=${currPage - 1}`
            );
            links.push({
                rel: "prev", 
                href: prevPath,
                key: "prev"
            });
        } else {
            links.push({
                rel: "prev", 
                href: "",
                key: "prev"
            });   
        }

        if (props.canonical.totalRecords) {
            const lastPage = Math.ceil(
                props.canonical.totalRecords / perPage
            );
            if (currPage < lastPage) {
                const nextPath = window.location.origin + routeObj.fullPath.replace(
                    `${pageKey}=${currPage}`,
                    `${pageKey}=${currPage + 1}`
                );
                links.push({
                    rel: "next", 
                    href: nextPath,
                    key: "next"
                });
            } else {
                if (currPage == lastPage) {
                    links.push({
                        rel: "next",
                        href: "",
                        key: "next"
                    });
                }
            }
        }

        return links;
    };

    metaInformation.link = calcCanonical(route);

    onBeforeRouteUpdate((to) => {
        metaInformation.link = calcCanonical(to);
    });

    watch(
        () => props.canonical.totalRecords,
        () => {
            metaInformation.link = calcCanonical(route);
        }
    );
}

useHead(metaInformation);
</script>  